define([], function () {
    var isBrowserIe = function () {
        return (
            !document.attachEvent || typeof document.attachEvent === "undefined"
        );
    };

    return function (callback) {
        if (callback && typeof callback === "function") {
            if (
                document.readyState === "complete" ||
                (document.readyState !== "loading" &&
                    !document.documentElement.doScroll)
            ) {
                return callback();
            }

            if (isBrowserIe()) {
                document.addEventListener("DOMContentLoaded", function () {
                    return callback();
                });
            } else {
                document.attachEvent("onreadystatechange", function () {
                    if (document.readyState === "complete") {
                        return callback();
                    }
                });
            }
        }
    };
});
